// import { useState } from 'react'
import { useQuery } from 'react-query'
import axios from 'axios'
import { API_URL } from '../../config'
import { rqDefaultOptions } from './defaultOptions'
import { useAuth0 } from '@auth0/auth0-react'

const getProjects = async (inputObj) => {
  let { partNumber, email } = inputObj.queryKey[1]
  if (!partNumber) partNumber = ''
  const parentPartAPIPath = `${API_URL}/api/part/v1/projects?partNumber=${partNumber}`
  axios.defaults.headers.common['Authorization'] = email
  const res = await axios.get(parentPartAPIPath).catch((err) => {
    throw err
  })
  return res.data
}

export function useProjects(setData, partNumber, email) {
  const options = {
    onSuccess: (data) => {
      if (partNumber) {
        setData([...data, 'All'])
      }
    },
    ...rqDefaultOptions,
  }
  const ppQuery = useQuery(['partProjects', { partNumber, email }], getProjects, options)
  return ppQuery
}
